import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute2 = ({
  width = 388,
  height = 398,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 1052,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 388 398"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M4.57102,200.106C3.89763,214.947 4.48737,224.404 6.39135,241.529C13.3434,304.057 107.775,337.059 154.122,345.743C185.985,350.086 236.243,365.284 182.364,391.337C115.016,423.904 169.329,308.834 214.952,289.294C251.45,273.662 250.436,242.252 245.367,228.502C229.435,198.83 225.815,119.511 338.786,39.6131C355.486,27.8019 373.002,13.2634 387.372,1.10645"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M4.57102,200.106C3.89763,214.947 4.48737,224.404 6.39135,241.529C13.3434,304.057 107.775,337.059 154.122,345.743C185.985,350.086 236.243,365.284 182.364,391.337C115.016,423.904 169.329,308.834 214.952,289.294C251.45,273.662 250.436,242.252 245.367,228.502C229.435,198.83 225.815,119.511 338.786,39.6131C355.486,27.8019 373.002,13.2634 387.372,1.10645"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M4.60218 196.668C4.72316 196.471 5.01172 196.479 5.12159 196.682L8.14289 202.268C8.25276 202.471 8.10153 202.717 7.87068 202.711L1.52228 202.534C1.29143 202.528 1.1541 202.274 1.27508 202.077L4.60218 196.668Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute2
